import { requestListConstants } from '../containers/Requests/request-list.constants';

const defaultState = {

}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case requestListConstants.SET_SELECTED_ROWS_COUNT: {
            
			return {
				...state,

			}
		}
		default:
			return state;
	}
}